// OUTPUT
//{ isReady, initial, validation, actualStep, title, label }

// INPUT
// initialValues, storeData, multistepData, prevRoute, nextRoute,

import { set, merge } from 'immutable';
import * as yup from 'yup';
import get from 'lodash/get';

const getNextStep = (currentStep, steps, data) => {
	if (currentStep.order > steps.length - 1) {
		return 'finish';
	}

	const currentStepIndex = currentStep.order;
	const nextStep = steps.find(step => step.order === currentStepIndex + 1);

	if (nextStep.dependency(data)) {
		return { ...nextStep };
	} else {
		return getNextStep(nextStep, steps, data);
	}
};

const getPrevStep = (currentStep, steps, data) => {
	if (currentStep.order < 2) {
		return 'start';
	}

	const currentStepIndex = currentStep.order;
	const prevStep = steps.find(step => step.order === currentStepIndex - 1);

	if (prevStep.dependency(data)) {
		return { ...prevStep };
	} else {
		return getPrevStep(prevStep, steps, data);
	}
};

const isReady = ({ multistepData, prevRoute, actualStep }) => {
	if (actualStep != null && multistepData != null && prevRoute != null) {
		return true;
	}
	return false;
};

const createInitialFromType = type => {
	if (type === 'jobId') return null;
	if (type === 'boolean') return null;
	if (type === 'check') return [];
	if (type === 'radio') return null;
	if (type === 'text') return null;
	if (type === 'switch') return { positive: null, negative: null };
};
const createValidationFromType = type => {
	if (type === 'boolean') return yup.boolean().required('É obrigatório selecionar umas das opções');
	if (type === 'check') return yup.array().of(yup.string()).min(1).required('É obrigatório selecionar umas das opções');
	if (type === 'text') return yup.string().required('É obrigatório preencher o campo');
	if (type === 'radio') return yup.string().typeError('É obrigatório selecionar umas das opções').required('É obrigatório selecionar umas das opções');
	if (type === 'switch')
		return yup
			.object()
			.shape({
				positive: yup.string().required('É obrigatório selecionar umas das opções como positiva'),
				negative: yup.string().required('É obrigatório selecionar umas das opções como negativa'),
			})
			.required('É obrigatório selecionar as opções');
};

export const actions = {
	NEXT_STEP: Symbol(),
	PREV_STEP: Symbol(),
	SET_MULTISTEP_DATA: Symbol(),
};

const reducer = (state, { action, payload }) => {
	switch (action) {
		case actions.NEXT_STEP:
			const nextStep = getNextStep(state.actualStep, state.multistepData, payload.data);
			// console.log('nextStep', nextStep, payload.data, nextStep.field, createInitialFromType(nextStep.type));
			return merge(state, {
				actualStep: nextStep,
				initial:
					state.staticFields != null
						? { [nextStep.field]: get(payload.data, nextStep.field, createInitialFromType(nextStep.type)), ...state.staticFields }
						: { [nextStep.field]: get(payload.data, nextStep.field, createInitialFromType(nextStep.type)) },
				validation: yup.object().shape({ [nextStep.field]: createValidationFromType(nextStep.type) }),
			});
		case actions.PREV_STEP:
			const prevStep = getPrevStep(state.actualStep, state.multistepData, payload.data);

			return merge(state, {
				actualStep: prevStep,
				initial:
					state.staticFields != null
						? { [prevStep.field]: get(payload.data, prevStep.field, createInitialFromType(prevStep.type)), ...state.staticFields }
						: { [prevStep.field]: get(payload.data, prevStep.field, createInitialFromType(prevStep.type)) },
				validation: yup.object().shape({ [prevStep.field]: createValidationFromType(prevStep.type) }),
			});
		case actions.SET_MULTISTEP_DATA:
			const newStep = payload.multistepData.steps[0];
			// console.log('set multi', newStep, payload.data, newStep.field, createInitialFromType(newStep.type));
			const newState = merge(state, {
				multistepData: payload.multistepData.steps,
				prevRoute: payload.prevRoute,
				title: payload.multistepData.title,
				staticFields: payload.multistepData.staticFields,
				actualStep: newStep,
				initial:
					payload.multistepData.staticFields != null
						? { [newStep.field]: get(payload.data, newStep.field, createInitialFromType(newStep.type)), ...payload.multistepData.staticFields }
						: { [newStep.field]: get(payload.data, newStep.field, createInitialFromType(newStep.type)) },
				validation: yup.object().shape({ [newStep.field]: createValidationFromType(newStep.type) }),
			});
			newState.isReady = isReady(newState);
			return newState;
	}
	return state;
};

export default reducer;
